import { Type } from "@angular/core";

export class ITemplate {
    constructor(public component: Type<any>, public data: any) {}
}
